export const waitForCondition = (opts) => {
    const { condition, callback, required = () => true, timeoutMS = 1000 } = opts;
    const waitForCondition = new Promise((resolve) => {
        const checkCondition = () => {
            if (!required() || condition()) {
                resolve();
            }
            else {
                setTimeout(checkCondition, timeoutMS);
            }
        };
        checkCondition();
    });
    waitForCondition.then(() => {
        if (typeof callback === "function" && required()) {
            callback();
        }
    });
};
